// Package imports:
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Style imports:
// import './EditBookmarkModal.scss';
// Component imports:
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
// Service imports:
import { formatDate } from '../../services/utils';
// Action imports:
import { editBookmark } from '../../redux-store/actions/bookmarkActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';
import { IBookmark } from '../../types/api/BookmarkTypes';

interface IOwnProps {
    bookmark: IBookmark,
    onHide(): void
};
type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps & IOwnProps;

interface IState {
    newComment: string,
    hasClicked: boolean
};

class EditBookmarkModal extends React.Component<Props, IState> {
    private formElement: HTMLFormElement | null
    constructor(props: Props) {
        super(props);
        this.state = {
            newComment: '',
            hasClicked: false
        };
        this.formElement = null;
    }

    render () {
        const { bookmark, onHide, accessTokenV2, editBookmark } = this.props;
        const { newComment, hasClicked } = this.state;
        return (
            <Modal
                show
                centered
                backdrop='static'
                onHide={onHide}
                id='EditBookmarkModal'
            >
                <Form
                    noValidate
                    validated={hasClicked}
                    ref={(el: HTMLFormElement | null) => { this.formElement = el; }}
                    onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if(this.formElement?.checkValidity()) {
                            editBookmark(accessTokenV2, bookmark.id, newComment);
                            onHide();
                        }
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Edit Bookmark
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='TableWrapper'>
                            <Table>
                                <tbody>
                                    <tr>
                                        <th>Symbol</th>
                                        <td>{bookmark.symbol}</td>
                                    </tr>
                                    <tr>
                                        <th>Timestamp</th>
                                        <td>{formatDate(bookmark.timestamp)}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Comment
                                        </th>
                                        <td>
                                            <Form.Control
                                                required
                                                value={newComment}
                                                onChange={e => this.setState({ newComment: e.target.value })}
                                                placeholder={bookmark.bmcomment}
                                            />
                                            <Form.Control.Feedback type='invalid'>Comment cannot be empty</Form.Control.Feedback>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>User</th>
                                        <td>{bookmark.username}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className='CloseButton'
                            variant='dark'
                            onClick={() => onHide()}
                        >
                            Close
                        </Button>
                        <Button
                            className='SaveButton'
                            type='submit'
                            variant='dark'
                            onClick={() => this.setState({ hasClicked: true })}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    }
}

function mapStateToProps({ loginReducer }: RootState) {
    const { accessTokenV2 } = loginReducer;
    return {
        accessTokenV2
    }
}

const connector = connect(mapStateToProps, { editBookmark });
export default connector(EditBookmarkModal);